import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { applyStoredTheme } from './hooks/useTheme.ts'
import { router } from './routes.tsx'
import './styles/tokens.css'
import './styles/base.css'

// Before the first paint, not in an effect: otherwise a light-theme user gets one dark frame.
applyStoredTheme()

// TanStack Query is the only cache (RULES §3). Refetch on window focus stays off: from stage 4 the
// /ws change events drive invalidation, and two sources of "refresh now" would fight each other.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

const root = document.getElementById('root')
if (!root) throw new Error('#root missing from index.html')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
